import App from '../../assets/js/app';
import SessionController from '../../assets/js/controllers/session';


export default class LoginForm {

	static selector = 'login-form';

	classes = {
		loading: 'is-loading',
		failed: 'has-failed'
	};

	constructor(container) {
		this.el = {
			container,
			steps: [
				{
					form: container.querySelector(`.${this.constructor.selector}__step--0 form`),
					inputs: {
						email: container.querySelector(`.${this.constructor.selector}__step--0 input[type="email"]`),
						password: container.querySelector(`.${this.constructor.selector}__step--0 input[type="password"]`),
						submit: container.querySelector(`.${this.constructor.selector}__step--0 button[type="submit"]`)
					}
				},
				{
					form: container.querySelector(`.${this.constructor.selector}__step--1 form`),
					inputs: container.querySelectorAll(`.${this.constructor.selector}__step--1 input`)
				}
			]
		};

		this.addEventListeners();

		this.checkLastEmail();
	}

	checkLastEmail() {
		const lastEmail = localStorage.getItem(SessionController.keys.userEmail);
		if (lastEmail) {
			this.el.steps[0].inputs.email.value = lastEmail;
			this.el.steps[0].inputs.password.focus();
			this.el.steps[0].inputs.password.select();
		} else {
			this.el.steps[0].inputs.email.focus();
		}
	}

	setStep0ReadOnly(boolean) {
		this.el.steps[0].inputs.email.readOnly = boolean;
		this.el.steps[0].inputs.password.readOnly = boolean;
		this.el.steps[0].inputs.submit.disabled = boolean;
	}

	#onStep0FormSubmit = (e) => {
		e.preventDefault();
		this.setStep0ReadOnly(true);
		this.el.container.classList.add(this.classes.loading);
		this.el.container.classList.remove(this.classes.failed);
		SessionController.login(new FormData(e.currentTarget))
			.then((data) => {
				if (data.state_token && data.devices) {
					this.state_token = data.state_token;
					this.devices = data.devices;
					this.el.container.setAttribute('data-step', 1);
					this.el.steps[1].inputs[0].focus();
					this.el.steps[1].inputs[0].select();
				} else {
					App.continue();
				}
			})
			.catch(() => {
				this.el.steps[0].inputs.password.focus();
				this.el.steps[0].inputs.password.select();
				this.el.container.classList.add(this.classes.failed);
			})
			.finally(() => {
				this.setStep0ReadOnly(false);
				this.el.container.classList.remove(this.classes.loading);
			});
	}

	#onStep1FormSubmit = (e) => {
		e.preventDefault();
	}

	#onStep1InputInput = (e) => {
		// TODO add copy past
		const { value } = e.currentTarget;
		if (value.length > 1) e.currentTarget.value = value[value.length - 1];
		let number = '';
		for (let i = 0, l = this.el.steps[1].inputs.length; i < l; ++i) {
			const input = this.el.steps[1].inputs[i];
			number += input.value;
			if (input === e.currentTarget) {
				const next = this.el.steps[1].inputs[i + 1];
				if (next) {
					next.focus();
					next.select();
					break;
				}
			}
		}
		if (number.length === 6) {
			e.currentTarget.blur();
			this.el.container.classList.add(this.classes.loading);
			this.el.container.classList.remove(this.classes.failed);
			const form = new FormData();
			form.append('state_token', this.state_token);
			form.append('device_id', this.devices[0].device_id);
			form.append('otp_token', number);
			SessionController.verify(form)
				.then(() => App.continue())
				.catch(() => {
					for (const input of this.el.steps[1].inputs) input.value = '';
					this.el.container.classList.add(this.classes.failed);
					this.el.steps[1].inputs[0].focus();
					this.el.steps[1].inputs[0].select();
				})
				.finally(() => {
					this.el.container.classList.remove(this.classes.loading);
				});
		}
	}

	addEventListeners() {
		this.el.steps[0].form.addEventListener('submit', this.#onStep0FormSubmit);
		this.el.steps[1].form.addEventListener('submit', this.#onStep1FormSubmit);
		for (const input of this.el.steps[1].inputs) {
			input.addEventListener('input', this.#onStep1InputInput);
		}
	}

	removeEventListeners() {
		this.el.steps[0].form.removeEventListener('submit', this.#onStep0FormSubmit);
		this.el.steps[1].form.removeEventListener('submit', this.#onStep1FormSubmit);
		for (const input of this.el.steps[1].inputs) {
			input.removeEventListener('input', this.#onStep1InputInput);
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
